module.exports = __webpack_public_path__ + "img/opening-hh.0e1184dd.jpg";